/* eslint-disable */
/*
====================================================
THIS IS AN AUTOGENERATED FILE
DO NOT EDIT. 
Update with `npm run graphql-codegen`
====================================================
*/
import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PatientAutocompleteQueryVariables = Types.Exact<{
  textQuery: Types.Scalars['String'];
  recentlyViewedOnly?: Types.InputMaybe<Types.Scalars['Boolean']>;
  myPanelOnly?: Types.InputMaybe<Types.Scalars['Boolean']>;
  serviceAreaCode?: Types.InputMaybe<Types.Scalars['String']>;
  dob?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type PatientAutocompleteQuery = { __typename?: 'Query', patientSearch: Array<{ __typename?: 'PatientSearchResult', id: string, label: string, emails: Array<string>, phones: Array<string>, dob?: any | null, serviceAreaName?: string | null, pcpName?: string | null }> };


export const PatientAutocompleteDocument = gql`
    query PatientAutocomplete($textQuery: String!, $recentlyViewedOnly: Boolean, $myPanelOnly: Boolean, $serviceAreaCode: String, $dob: String) {
  patientSearch(textQuery: $textQuery, recentlyViewedOnly: $recentlyViewedOnly, myPanelOnly: $myPanelOnly, serviceAreaCode: $serviceAreaCode, dob: $dob) {
    id
    label
    emails
    phones
    dob
    serviceAreaName
    pcpName
  }
}
    `;

/**
 * __usePatientAutocompleteQuery__
 *
 * To run a query within a React component, call `usePatientAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientAutocompleteQuery({
 *   variables: {
 *      textQuery: // value for 'textQuery'
 *   },
 * });
 */
export function usePatientAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<PatientAutocompleteQuery, PatientAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientAutocompleteQuery, PatientAutocompleteQueryVariables>(PatientAutocompleteDocument, options);
      }
export function usePatientAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientAutocompleteQuery, PatientAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientAutocompleteQuery, PatientAutocompleteQueryVariables>(PatientAutocompleteDocument, options);
        }
export type PatientAutocompleteQueryHookResult = ReturnType<typeof usePatientAutocompleteQuery>;
export type PatientAutocompleteLazyQueryHookResult = ReturnType<typeof usePatientAutocompleteLazyQuery>;
export type PatientAutocompleteQueryResult = Apollo.QueryResult<PatientAutocompleteQuery, PatientAutocompleteQueryVariables>;